




















import Vue, {
  PropType
} from 'vue';
import ImageCarousel from '@/components/image-slider/ImageCarousel.vue';
import { Photos } from '@/types';
import { EventType } from '@/constants';
export default Vue.extend({
  name: 'lightboxSlider',
  components: {
    ImageCarousel
  },
  props: {
    images: {
      type: Array as PropType<Photos[]>,
      required: true
    },
    position: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    ifLast (): boolean {
      return this.currentPostion === this.imageUrls.length - 1;
    },
    ifFirst (): boolean {
      return this.currentPostion === 0;
    }
  },
  beforeMount () {
    this.currentPostion = this.position;
    this.imageUrls = this.images.map((image: any) => image.assetValue);
    window.document.body.classList.add(this.styleClass);
  },
  data () {
    return {
      imageUrls: [] as string[],
      currentPostion: 0,
      close: false as boolean,
      styleClass: 'overflow-hidden'
    }
  },
  methods: {
    updatePosition (position: number) {
      this.currentPostion = position;
    },
    imageDate (isoDate: any) {
      if (isoDate) {
        const date = new Date(isoDate);
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to month since it's zero-based
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        let hour = date.getHours();
        const minute = date.getMinutes().toString().padStart(2, '0');
        const amPm = hour >= 12 ? 'pm' : 'am';
        if (hour > 12) {
          hour -= 12;
        }
        hour = Number(hour.toString().padStart(2, '0'));
        const formattedDate = `${month}/${day}/${year} ${hour}:${minute}${amPm}`;
        return formattedDate;
      }
      return '';
    }
  },
  watch: {
    close () {
      if (this.close) {
        window.document.body.classList.remove(this.styleClass);
        this.$emit(EventType.CLOSE_MODAL);
      }
    }
  }
})
